import { useAppSelector } from '@store/hooks';
import { getLocalisation } from '@store/localisation';

export function useSupportSalesWhatsApp(): string | undefined {
  const { supportSalesWhatsApp } = useAppSelector(getLocalisation);

  return supportSalesWhatsApp;
}
